import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useHeaderFilters } from '@/features/header-filters';

import { useReceiveLossesFilters } from '../model';
import { ReceiveLossesFilters } from './receive-losses-filters';
import { ReceiveLossesPage } from './receive-losses-page';

export function ReceiveLossesWithFilters() {
  const { t } = useTranslation();
  const { setFilterConfig, setSearchConfig } = useHeaderFilters();

  const {
    urlState,
    searchQuery,
    activeFiltersCount,
    activeFilters,
    isFiltersDirty,
    hasDefaultFilters,
    handleFilterChange,
    handleDateRangeChange,
    handleSearchChange,
    handleReset,
    handleApplyFilters
  } = useReceiveLossesFilters();

  useEffect(() => {
    setSearchConfig({
      defaultValue: searchQuery,
      placeholder: t('gen.search.desc', 'Search among relevant properties'),
      onChange: handleSearchChange,
      enabled: true
    });
  }, [handleSearchChange, searchQuery, setSearchConfig, t]);

  useEffect(() => {
    const filterContent = (
      <ReceiveLossesFilters
        filters={urlState}
        onFilterChange={handleFilterChange}
        onDateRangeChange={handleDateRangeChange}
      />
    );

    setFilterConfig({
      id: 'receive-losses-filters',
      title: t('receive.losses.filters.title', 'Filter Lost or Not Sent Items'),
      content: filterContent,
      activeCount: activeFiltersCount,
      activeFilters,
      onReset: handleReset,
      onApply: handleApplyFilters,
      onClearAll: handleReset,
      isApplyDisabled: !isFiltersDirty,
      isResetDisabled: hasDefaultFilters
    });
  }, [
    activeFiltersCount,
    activeFilters,
    handleApplyFilters,
    handleDateRangeChange,
    handleFilterChange,
    handleReset,
    hasDefaultFilters,
    isFiltersDirty,
    setFilterConfig,
    t,
    urlState
  ]);

  return <ReceiveLossesPage />;
}
